import { handleAPIError } from "@services/Base";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { SCENARIO_API_URL } from "../../../config";

export interface IDeleteScenarioMutation {
  scenario_id: string;
}
export const useModelDeleteScenario = () => {
  return useMutation({
    mutationFn: (props: IDeleteScenarioMutation) =>
      axios
        .delete(
          `${SCENARIO_API_URL}/waves-scenario-manager-api/v1/scenarios/${props.scenario_id}`,
          {}
        )
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
